import { createContext } from "react";

export const EmpresaContext = createContext()
export const EmpresaFormContext = createContext()
export const EmpresaReportContext = createContext()